/**
 * Kassabon in de lade (snippets/smokkelaar-kassabon.liquid): open als het scherm
 * er hoog genoeg voor is, anders ingeklapt onder "Bekijk opbouw".
 *
 * Horizon laat de samenvatting los (niet plakkend, afrekenknop pas na scrollen)
 * zodra hij hoger is dan 55% van de lade (assets/cart-drawer.js). De volledige
 * bon past daaronder pas vanaf RUIM; kleiner (en op elke telefoon) blijft alleen
 * het totaal staan. Dezelfde mediaquery staat in snippets/smokkelaar-styles.liquid
 * (daar verdwijnt dan de knop). Horizons morph bewaart details.open bij een
 * herrender, dus dit hoeft alleen bij het laden en als het scherm wisselt.
 */

const RUIM = window.matchMedia('(min-width: 750px) and (min-height: 780px)');

class SmokkelaarKassabon extends HTMLElement {
  #zet = () => {
    const details = this.querySelector('details');
    if (details) details.open = RUIM.matches;
  };

  connectedCallback() {
    this.#zet();
    RUIM.addEventListener('change', this.#zet);
  }

  disconnectedCallback() {
    RUIM.removeEventListener('change', this.#zet);
  }
}

if (!customElements.get('smokkelaar-kassabon')) {
  customElements.define('smokkelaar-kassabon', SmokkelaarKassabon);
}
